'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { BaseFieldProps } from '@/ui-kit/field';
import { UiKitInput } from '@/ui-kit/input';
import { UiKitRadioGroup } from '@/ui-kit/radio-group';
import { UiKitRadioTile } from '@/ui-kit/radio-tile';

import { styles } from './SendDateSelector.styles';
import { beforeDateMaskedStateChange, beforeTimeMaskedStateChange } from './utils';

export interface SendDateSelectorProps {
  getFieldProps: (name: string) => BaseFieldProps;
}

export function SendDateSelector({ getFieldProps }: SendDateSelectorProps) {
  const slots = styles();
  const t = useTranslations();

  const [sendGiftCard, setSendGiftCard] = useState<string>('immediately');

  return (
    <div className={slots.base()}>
      <input
        type="hidden"
        name="sendGiftCard"
        value={sendGiftCard}
      />
      <UiKitRadioGroup
        value={sendGiftCard}
        onChange={setSendGiftCard}
        classNameInner={slots.grid()}
      >
        <UiKitRadioTile
          value="immediately"
          label={t('giftCard.sendDateSelector.sendImmediately')}
        />
        <UiKitRadioTile
          value="selectDateTime"
          label={t('giftCard.sendDateSelector.selectDateTime')}
        />
      </UiKitRadioGroup>

      {sendGiftCard === 'selectDateTime' && (
        <div className={slots.grid()}>
          <UiKitInput
            label={t('date')}
            mask="99.99.9999"
            beforeMaskedStateChange={beforeDateMaskedStateChange}
            {...getFieldProps('sendDate')}
          />
          <UiKitInput
            label={t('time')}
            mask="99:99"
            beforeMaskedStateChange={beforeTimeMaskedStateChange}
            {...getFieldProps('sendTime')}
          />
        </div>
      )}
    </div>
  );
}
